const env = {
  // Endpoint principal del chat; usa .env y, si no existe, el API Gateway indicado
  API_URL:
    process.env.REACT_APP_API_URL ||
    "https://nbv4ejg6u4.execute-api.us-east-1.amazonaws.com/Prod/chat",
  // Endpoint dedicado para chat (sugerencias, historial). Úsalo en lugar de API_URL si existe.
  CHAT_URL:
    process.env.REACT_APP_CHAT_URL ||
    "https://nbv4ejg6u4.execute-api.us-east-1.amazonaws.com/Prod/chat",
  WALL_API_URL: process.env.REACT_APP_WALL_API_URL,
  WALL_WS_URL: process.env.REACT_APP_WALL_WS_URL || "wss://g0hbuqux26.execute-api.us-east-1.amazonaws.com/Prod/", // WebSocket para eventos en tiempo real
  API_KEY: process.env.REACT_APP_X_API_KEY,
};

export default env;
